module.exports = __webpack_public_path__ + "static/img/person2.78d2aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/person2.png
// module id = q6VQ
// module chunks = 1